var defaults = {
    strict: true
};
var cond = function (pairs, options) {
    if (options === void 0) { options = defaults; }
    var match = pairs.find(function (_a) {
        var predicate = _a[0];
        return options.strict ? predicate === true : predicate;
    });
    if (!match)
        return null;
    return typeof match[1] === 'function' ? match[1]() : match[1];
};
export default cond;
